import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/*
  loadData: loader z komponentu,
  trigbgeredFields: pola które mają wywoływać loader,
  fakeHistory: podajemy scieżkę na jaką ma działać loader jeżli chcemy wykonać z innego routa (nie używać jak nie trzeba !)
*/
export const useMessageReceived = (
  loadData,
  { triggeredFields = [], fakeHistory = null } = {}
) => {
  // const dispatch = useDispatch();
  // const loadRightBoxAlerts = () => dispatch(loadRightBoxAlert());
  let history = useHistory();
  const ws = useSelector((state) => state.socket.ws);

  if (Boolean(fakeHistory)) {
    history = { location: { pathname: fakeHistory } };
  }

  useEffect(() => {
    if (Boolean(ws)) {
      ws.onmessage = ({ data }) => {
        const {
          location: { pathname },
        } = history;
        const { content } = JSON.parse(data);
        if (content.includes(pathname)) {
          loadData();
        }
        // loadRightBoxAlerts();
      };
    }
    // eslint-disable-next-line
  }, [ws, ...triggeredFields]);
};
